import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { LanguageProvider } from './contexts/LanguageContext';
render(<LanguageProvider data-id="element-445">
    <App data-id="element-446" />
  </LanguageProvider>, document.getElementById('root'));